import { IngredientCategory, INGREDIENTS_ICONS } from "../../constants";
import styles from "./styles.module.scss";

interface IngredientImageProps {
  image?: string | null;
  category?: IngredientCategory;
  width?: number;
  height?: number;
}

const IngredientImage: React.FC<IngredientImageProps> = ({
  image,
  category,
  width = 100,
  height = 100,
}) => {
  return (
    <div
      style={{
        minWidth: width,
        width: width,
        height: height,
      }}
      className={styles.wrapper}
    >
      {!image && category && INGREDIENTS_ICONS[category]}
      {image && <img src={image} className={styles.image} />}
    </div>
  );
};

export default IngredientImage;
